import * as THREE from 'three'
import { OrbitControls } from 'three/addons/controls/OrbitControls.js'
import Producer from '../Producer.js'

const FOV = 70

/**
 * 3D 透視相機與控制控制器
 */
export default class Camera {
    constructor() {
        this.producer = new Producer()
        this.scene = this.producer.scene
        this.sizes = this.producer.sizes
        this.canvas = this.producer.canvas
        this.debug = this.producer.debug

        this.setInstance()
    }

    setInstance() {
        const aspect = this.sizes.width / this.sizes.height

        // 建立透視相機
        this.instance = new THREE.PerspectiveCamera(FOV, aspect, 0.1, 100)
        this.instance.position.set(0, 0, 3)
        this.scene.add(this.instance)

        this.instance.lookAt(0, 0, 0)

        // 初始化 OrbitControls
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true
        this.controls.dampingFactor = 0.05
        this.controls.target.set(0, 0, 0)

        // 旋轉權限僅在 Debug 模式開啟（供 Carousel bake/除錯使用）
        this.controls.enabled = Boolean(this.debug?.active)
        this.controls.enableRotate = Boolean(this.debug?.active)
        this.controls.enableZoom = false
        this.controls.enablePan = false
        this.controls.update()

        this.debug?.addCamera?.(this, this.canvas)
    }

    /** 響應式尺寸切換：只更新 aspect，FOV 固定不變 */
    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    /** 每幀由 Render Loop 驅動更新 OrbitControls 阻尼 */
    update() {
        this.controls?.update()
    }

    /** 銷毀相機與 OrbitControls 事件監聽 */
    destroy() {
        this.controls?.dispose()
        if (this.instance.parent) {
            this.instance.parent.remove(this.instance)
        }
    }
}
